module.exports = __webpack_public_path__ + "static/media/bank.3e7637a3.svg";